// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iconn_button .v-btn {
  text-transform: none;
}
.iconn_button .v-btn__overlay {
  background-color: unset;
}`, "",{"version":3,"sources":["webpack://./../../_design_system/vue_v2/src/components/atoms/Button.vue","webpack://./../Button.vue"],"names":[],"mappings":"AAEE;EACE,oBAAA;ACDJ;ADIE;EACE,uBAAA;ACFJ","sourcesContent":["\n.iconn_button {\n  .v-btn {\n    text-transform: none;\n  }\n\n  .v-btn__overlay {\n    background-color: unset;\n  }\n}\n",".iconn_button .v-btn {\n  text-transform: none;\n}\n.iconn_button .v-btn__overlay {\n  background-color: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
